<template>
  <div class="sign-in-page">
    <TheBreadcrumbs :links="breadCrumbsLinks"/>
    <div class="sign-in-page__content container">
      <div class="sign-in-page__inner container-inner">
<!--        <h1 v-if="startUserType === EMPLOYEE"-->
<!--            class="sign-in-page__title">{{ $tAuth('Free and official employment') }}</h1>-->
        <div class="sign-in-page__main">
          <SignInFormPartner v-if="isPartner"
                             class="sign-in-page__form"/>
          <SignInForm v-else
                      :key="isPartner ? 1 : 2"
                      :previousPage="previousPage"
                      :isPartner="isPartner"
                      :startUserType="null"
                      class="sign-in-page__form"/>

          <SignInSide class="sign-in-page__side"
                      :isPartner="isPartner"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TheBreadcrumbs from '../../components/Breadcrumbs'
  import SignInForm from '../../components/SignIn/SignInForm'
  import SignInSide from '../../components/SignIn/SignInSide'
  import SignInFormPartner from '../../components/SignIn/SignInFormPartner'
  import globalMetaMixin from '@/mixins/globalMetaMixin'
  import {setMetaRobots} from '@/helpers/metaRobots'
  import {removeCanonicalTag} from "@/router/common/setCanonical"
  import {PARTNER, EMPLOYEE} from '@/constants/usersTypes'

  export default {
    name: 'SignIn',
    mixins: [globalMetaMixin],
    components: {
      SignInFormPartner,
      SignInForm,
      TheBreadcrumbs,
      SignInSide
    },
    data() {
      return {
        previousPage: null,
        startUserType: null,
        EMPLOYEE,
      }
    },
    computed: {
      isPartner() {
        return this.isRouteNameMixin('auth-partner')
      },
      breadCrumbsLinks() {
        return [{
          name: this.$tAuth('Authorization / registration')
        }]
      }
    },
    beforeRouteEnter(to, from, next) {
      if (from.name && to.name !== from.name) {
        return next(vm => {
          vm.previousPage = from
        })
      }

      next()
    },
    methods: {
      getUserType() {
        if (this.isPartner) {
          return PARTNER
        }

        let startUserType = +this.$route.query.user_type

        return !isNaN(startUserType) ? startUserType : EMPLOYEE
      }
    },
    created() {
      const title = this.isPartner ? 'auth-partner-meta-title' : 'auth-meta-title'
      const description = this.isPartner ? 'auth-partner-meta-description' : 'auth-meta-description'

      this.setMetaTitleMixin(this.$tMeta(title))
      this.setMetaDescriptionMixin(this.$tMeta(description))

      setMetaRobots('noindex, follow')
      removeCanonicalTag()

      this.startUserType = this.getUserType()
    }
  }
</script>

<style>

</style>
